import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import initialstate from '../initialstate';

export function itAppSOReducer(state = initialstate.itApplications, action) {
	const deleteItApplicationFromState = (itApplicationId) => {
		let tempState = _.cloneDeep(state);
		tempState.data = tempState.data.filter((itapp) => itapp.id !== Number(itApplicationId));
		return tempState;
	};
	switch (action.type) {
		case types.GET_ALL_IT_APPS:
			return action.response || state;

		case types.GET_IT_APP_BY_ID:
			if (isApiResponseOk(action)) {
				return {
					...state,
					selectedItApplication: action.response
				};
			} else if (action?.error?.response.status === HttpStatusCodes.NotFound)
				// If the IT Application is not found, remove it from the list (concurrency scenario)
				return deleteItApplicationFromState(action.itApplicationId);
			return state;
		case types.DELETE_IT_APPS_BY_ID: {
			if (isApiResponseOk(action) || action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteItApplicationFromState(action.itApplicationId);
			}
			return state;
		}

		case types.CLEAR_IT_APPLICATION:
			return {
				...state,
				selectedItApplication: null
			};
		case types.CREATE_IT_APP: {
			if (isApiResponseOk(action) && action.response) {
				let newState;

				if (Object.keys(state).length === 0) {
					newState = {
						data: [action.response]
					};
				} else {
					newState = _.cloneDeep(state);
					newState.data = [..._.cloneDeep(state.data), action.response];
				}
				return newState;
			}
			return state;
		}
		case types.UPDATE_IT_APPS_BY_ID: {
			let newState = _.cloneDeep(state);
			if (isApiResponseOk(action)) {
				newState = _.cloneDeep(state);
				newState.data[newState.data.findIndex((i) => i.id === action.response.id)] = action.response;
			}
			return newState;
		}
		case types.UNRELATE_ITSOAPP_FROM_SCOT: {
			let newState = _.cloneDeep(state);
			if (isApiResponseOk(action)) {
				newState = action.response;
			}
			return newState;
		}
		default:
			return state;
	}
}
